import React from 'react';

import {CompletedQueryContentWithPresentations} from './completed-query-content-with-presentations';
import {useGetPresentations} from './results-graph/requests/use-get-presentations';
import {QueryLayoutLoading} from '../query-layout-loading';
import {useQueryResultMaxLengthOptions} from './results-graph/requests/use-query-result-max-length-options';
import {GlobalVersionData} from '../../../../hooks/global-version/use-global-version-query';

interface Props {
    selectedQuery: CompletedQuery;
    globalVersions: GlobalVersionData[];
}

export function CompletedQueryContent(props: Props) {
    const presentationsRequest = useGetPresentations(props.selectedQuery.id);
    const maxLengthOptionsRequest = useQueryResultMaxLengthOptions(props.selectedQuery.id);

    if (!presentationsRequest.data || !maxLengthOptionsRequest.data) {
        return <QueryLayoutLoading />;
    }

    return (
        <CompletedQueryContentWithPresentations
            selectedQuery={props.selectedQuery}
            globalVersions={props.globalVersions}
            presentations={presentationsRequest.data}
            maxPathLengthOptions={maxLengthOptionsRequest.data}
        />
    );
}
